import React from 'react'
import { PropTypes } from 'prop-types'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const Page = props => <div {...css(props.styles.page)}>{props.children}</div>

Page.propTypes = {
  children: PropTypes.node,
  styles: PropTypes.object.isRequired
}

export default withStyles(Styles)(Page)



// WEBPACK FOOTER //
// ./components/page/index.js